export default {
      id: "notifications__approaching_object-usage",
      viewBox: "0 0 24 24",
      url: __webpack_public_path__ + "img/icons.svg#notifications__approaching_object",
      toString: function () {
        return this.url;
      }
    }